/**
 * 翻车作业进度与效率看板 — POST /api/produce/kanban/dumper-realtime-overview
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/dumper-realtime-overview'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchCarDumperOpcMonitor(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(unwrap)
}
